import React, { useState } from "react";

const MapLegend = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`map-legends ${isCollapsed ? "is-collapsed" : ""}`}>
      {!isCollapsed && (
        <a
          className="btn-legend-close"
          href="#"
          title="Close"
          onClick={(e) => setIsCollapsed(true)}
        >
          &times;
        </a>
      )}

      {isCollapsed && (
        <a
          className="btn-legend-toggle"
          title="Toggle"
          href="#"
          onClick={(e) => setIsCollapsed(!isCollapsed)}
        >
          &rarr;
        </a>
      )}
      {!isCollapsed && (
        <a
          className="btn-legend-toggle"
          title="Show"
          href="#"
          onClick={(e) => setIsCollapsed(!isCollapsed)}
        >
          &larr;
        </a>
      )}

      <div className="legends-wrapper" onClick={e => isCollapsed ? setIsCollapsed(false) : false}>
        <div className="map-legend">
          <img
            className="map-legend_icon"
            alt="soapy"
            src="/images/pin-normal-soapy.png"
          />{" "}
          <span> Soapy</span>
        </div>
        <div className="map-legend">
          <img
            className="map-legend_icon"
            alt="massage"
            src="/images/pin-normal.png"
          />{" "}
          <span> Massage</span>
        </div>
        <div className="map-legend">
          <img
            className="map-legend_icon"
            alt="go go"
            src="/images/pin-normal-go-go.png"
          />{" "}
          <span> Go-go</span>
        </div>
        <div className="map-legend">
          <img
            className="map-legend_icon"
            alt="Gentlemen’s Clubs"
            src="/images/pin-normal-gentlemens-clubs.png"
          />{" "}
          <span> Gentlemen’s Clubs</span>
        </div>
        <div className="map-legend">
          <img
            className="map-legend_icon"
            alt="Freelancers"
            src="/images/pin-normal-fl.png"
          />{" "}
          <span> Freelancers</span>
        </div>
        <div className="map-legend">
          <img
            className="map-legend_icon"
            alt="Red light districts"
            src="/images/pin-normal-rld.png"
          />{" "}
          <span> Red Light Districts</span>
        </div>
      </div>
    </div>
  );
};

export default MapLegend;
